module.exports = __webpack_public_path__ + "img/nl.c3d589c2.png";